export default {
  SET_POINTS(state, data) { state.points = data; },
};
